import React, { useState, useEffect } from "react"
import Cookies from "universal-cookie"
import { lambdaCall } from "../../services/lambdaCall"
import LocationPopup from "./LocationPopup"
import { withTranslation } from "gatsby-plugin-react-i18next"
import { getSignupFormId } from "../../services/klaviyo"

const DESKTOP_FORM_ID = getSignupFormId()
const MOBILE_FORM_ID = getSignupFormId("mobile")

const NewsletterPopupContent = ({ alternatePath }) => {
  const [isLocationPopupOpen, setLocationPopupOpen] = useState(false)

  const handleLocationPopup = (isOpen) => {
    setLocationPopupOpen(isOpen)
  }

  const getNextYear = () => {
    const current = new Date()
    const nextYear = new Date()
    nextYear.setFullYear(current.getFullYear() + 1)
    return nextYear
  }

  const checkLocation = async () => {
    const cookies = new Cookies()
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams
    const countryParam = searchParams.get("country")

    if (countryParam) {
      cookies.set("country", countryParam, {
        path: "/",
        expires: getNextYear(),
      })
    }

    const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"
    const countryCookie = cookies.get("country")

    try {
      if (!countryCookie) {
        const response = await lambdaCall({
          method: "GET",
          url: "ipgeolocation",
        })
        const data = await response.json()

        if (response.status === 200) {
          const country = data.region

          cookies.set("country", country, {
            path: "/",
            expires: getNextYear(),
          })

          if (country !== activeEnv) {
            handleLocationPopup(true)
          }
        } else {
          cookies.set("country", activeEnv, {
            path: "/",
            expires: getNextYear(),
          })
        }
      } else if (activeEnv !== countryCookie) {
        handleLocationPopup(true)
      }
    } catch (error) {
      cookies.set("country", activeEnv, {
        path: "/",
        expires: getNextYear(),
      })
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      const currentUrl = new URL(window.location.href)
      const searchParams = currentUrl.searchParams
      const signup = searchParams.get("signup")

      if (signup) {
        const _klOnsite = window._klOnsite || []
        const formId =
          window.innerWidth >= 600 ? DESKTOP_FORM_ID : MOBILE_FORM_ID
        if (_klOnsite !== undefined) {
          _klOnsite.push(["openForm", formId])
        }
        return
      }
    }

    const fetchData = async () => {
      await checkLocation()
    }

    fetchData()
  }, [])

  return (
    <LocationPopup
      handlePopup={handleLocationPopup}
      isOpen={isLocationPopupOpen}
      alternatePath={alternatePath}
    />
  )
}

export default withTranslation()(NewsletterPopupContent)
